<!-- Home Banner -->

<section class="banner-section">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="banner-content aos" data-aos="fade-up" data-aos-duration="2000">
          <h1>Prenez <span>rendez-vous </span> avec <span> un médecin,</span>

              En toute  <span> confiance.</span></h1>
          <img src="assets/img/icons/header-icon.svg" class="header-icon" alt="header-icon"/>
          <p> Pour vous, vos enfants ou vos parents, trouvez un professionnel de santé à proximité En cabinet ou en téléconsultation. </p>

        </div>
        <div
          class="search-box-one aos"
          data-aos="fade-up"
          data-aos-duration="2000">
          <form [formGroup]="form">
            <div class="search-input search-line ">
              <i class="feather icon-search bficon"></i>
              <div class="mb-0">
                <input type="text" formControlName="term"  placeholder=" {{ 'PORTAL.HOME.HOME-DETAILS.SEARCH-PLACEHOLDER' | translate }}" />
              </div>
            </div>
            <div class="search-input search-map-line">
              <i class="feather icon-map-pin"></i>
              <div class="mb-0">
                <input type="text"  formControlName="emplacement" placeholder="{{ 'PORTAL.HOME.HOME-DETAILS.LOCATION-PLACEHOLDER' | translate }}"/>
                <a class="current-loc-icon current_location" href="javascript:void(0);">
                  <i class="feather icon-crosshair"></i>
                </a>
              </div>
            </div>
            <div class="form-search-btn">
              <button  (click)=" onSearch()" class="btn" type="button"  >
                  {{ 'ADMIN.BUTTONS.SEARCH-PLACE-HOLDER' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="banner-img aos" data-aos="fade-up" data-aos-duration="2000">
          <img
            src="assets/img/doc.png"
            class="img-fluid"
            alt="patient-image"
          />
        </div>
      </div>
    </div>
  </div>
</section>
<!-- /Home Banner -->

<app-specialties-section></app-specialties-section>

<!-- Service Section -->
<section class="why-choose-section" style="background-color: #F8FAFC;">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-inner-header text-center mt-5">
                    <h2>Nos Services</h2>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-3 col-md-6 d-flex">
                <div class="card why-choose-card w-100">
                    <div class="card-body">
                        <div class="why-choose-icon">
                            <span><img src="assets/img/icons/choose-02.svg" alt="choose-image"></span>
                        </div>
                        <div class="why-choose-content">
                            <h4>Accédez rapidement aux soins</h4>
                            <p>
                                Prenez rendez-vous en ligne pour des consultations en présentiel ou à distance, et recevez des rappels pour ne rien oublier.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex">
                <div class="card why-choose-card w-100">
                    <div class="card-body">
                        <div class="why-choose-icon">
                            <span><img src="assets/img/icons/choose-04.svg" alt="choose-image"></span>
                        </div>
                        <div class="why-choose-content">
                            <h4>
                                Profitez d’un suivi personnalisé
                            </h4>
                            <p>
                                Communiquez facilement avec vos professionnels de santé, recevez des conseils adaptés et restez accompagné à chaque étape.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex">
                <div class="card why-choose-card w-100">
                    <div class="card-body">
                        <div class="why-choose-icon">
                            <span><img src="assets/img/icons/angry.svg" alt="choose-image"></span>
                        </div>
                        <div class="why-choose-content">
                            <h4>
                                Maîtrisez votre dossier médical
                            </h4>
                            <p>
                                Centralisez vos documents de santé en toute sécurité et gérez ceux de vos proches depuis un seul espace.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Work Section -->
<section class="work-section mb-5">
  <div class="container">
    <div class="row">
      <div
        class="col-lg-4 col-md-12 work-img-info aos"
        data-aos="fade-up"
        data-aos-duration="2000">
        <div class="work-img">
          <img src="assets/img/work-img.png" class="img-fluid" alt="doctor-image"/>
        </div>
      </div>
      <div class="col-lg-8 col-md-12 work-details">
        <div
          class="section-header-one aos"
          data-aos="fade-up"
          data-aos-duration="2000">
          <h5>{{ 'PORTAL.HOME.HOME-DETAILS.WORK-SECTION.TITLE' | translate }}</h5>
          <h2 class="section-title">Vous êtes professionnel de santé ?</h2>
            <h5 class="mt-3">
                Découvrez 3iyadaty, la solution pensée pour faciliter votre quotidien.
            </h5>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 aos" data-aos="fade-up">
            <div class="work-info">
              <div class="work-icon">
                <span
                ><img
                  src="assets/img/icons/work-01.svg"
                  alt="search-doctor-icon"
                /></span>
              </div>
              <div class="work-content">
                <h5>
                    Offrez une prise en charge optimale à vos patients
                </h5>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 aos" data-aos="fade-up">
            <div class="work-info">
              <div class="work-icon">
                <span
                ><img
                  src="assets/img/icons/work-02.svg"
                  alt="doctor-profile-icon"
                /></span>
              </div>
              <div class="work-content">
                <h5> Améliorez votre organisation et votre confort de travail</h5>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 aos" data-aos="fade-up">
            <div class="work-info">
              <div class="work-icon">
                <span
                ><img src="assets/img/icons/work-03.svg" alt="calendar-icon"
                /></span>
              </div>
              <div class="work-content">
                <h5>Développez sereinement votre activité et vos revenus</h5>

              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 aos" data-aos="fade-up">
            <div class="work-info">
              <div class="work-icon">
                <span
                ><img src="assets/img/icons/flow-chart-icon-02.svg" alt="solution-icon"
                /></span>
              </div>
              <div class="work-content">
                <h5>Rejoignez les nombreux professionnels qui ont déjà adopté 3iyadaty au Maroc</h5>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- protection Section -->
<section class="way-section mt-5">
    <div class="container">
        <div class="way-bg">
            <div class="way-shapes-img mb-3">
                <div class="way-shapes-left ">
                    <img src="assets/img/shape-06.png" alt="shape-image">
                </div>
                <div class="way-shapes-right ">
                    <img src="assets/img/shape-07.png" alt="shape-image">
                </div>
            </div>
            <div class="row align-items-end">
                <div class="col-lg-7 col-md-12">
                    <div class="section-inner-header way-inner-header mb-0">
                        <h2>Santé connectée, vie privée protégée.</h2>
                        <p>Chez 3iyadaty, la confidentialité de vos données personnelles et médicales est au cœur de nos engagements.
                            Nous mettons en œuvre les technologies de sécurité les plus avancées pour garantir la protection de vos informations, en toute transparence.</p>
                    </div>
                </div>
                <div class="col-lg-5 col-md-12 " >
                    <div  class=" way-img"  style="margin-top: 50px;">
                        <img src="assets/img/home-16.png" class="img-fluid mt-5" alt="doctor-way-image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- /protection Section -->



<!-- apli-3iyadaty Section -->
<section class="position-relative" >
    <div class="container">
        <div class="row g-4">
            <div class="col-lg-6 mt-5" style="margin-top: 8rem !important;">
                <div>
                    <h2 class="mb-4 fw-bold">Découvrez 3iyadaty une technologie qui travaille en silence, au service de votre succès.</h2>
                    <p class="lead text-muted">
                        Une solution intuitive et simple d'utilisation,
                        qui centralise les rendez-vous, les dossiers patients, la gestion humaine et financière et permet le pilotage global de toute l'activité de votre cabinet
                    </p>


                </div>

            </div>

            <div class="col-lg-6">
                <div class="d-flex flex-column">
                    <div class="ratio ratio-16x9 shadow rounded-3 overflow-hidden w-100">
                        <video controls class="w-100">
                            <source src="assets/video/apli-3iyadaty.mp4" type="video/mp4">
                        </video>
                    </div>
                    <div class="form-search-btn mt-5 text-center">
                        <h1>Découvrez 3iyadaty en action !</h1>
                        <p>
                            Réservez votre démo personnalisée dès aujourd'hui et simplifiez la gestion de votre santé.
                        </p>
                        <div class="d-flex justify-content-center mt-5">
                            <a href="https://forms.fillout.com/t/6G27mPucrjus" class="btn btn-primary  btn-bounce mb-5 btn-lg px-5 py-3 fw-bold" target="_blank">
                                Réserver une démo
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- /apli-3iyadaty Section -->


<!--  functionality Section -->
<section class="services-section-fourteen">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 aos" data-aos="fade-up">
                <div class="section-header-fourteen service-inner-fourteen">
                    <div class="service-inner-fourteen"></div>
                    <h1 class="text-center">Nos Fonctionnalités</h1>
                </div>
            </div>
        </div>
        <div class="row row-gap justify-content-center">
            <div class="col-lg-3 col-md-6 col-sm-12 aos" data-aos="fade-up">
                <div class="our-services-list">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <i class="fas fa-calendar-check" style="color: #26948e; font-size: 2rem;"></i>
                        <h5 class="mt-2">Gestion intelligente</h5>
                    </div>
                    <p class="mt-3">Réservation 24h/24 et 7j/7, avec des créneaux personnalisables par praticien.</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 aos" data-aos="fade-up">
                <div class="our-services-list">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <i class="fas fa-user-md" style="color: #26948e; font-size: 2rem;"></i>
                        <h5 class="mt-2">Suivi patient digitalisé</h5>
                    </div>
                    <p class="mt-3" >Historique médical complet avec suivi des consultations, ordonnances et examens.</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 aos" data-aos="fade-up">
                <div class="our-services-list">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <i class="fas fa-chart-line" style="color: #26948e; font-size: 2rem;"></i>
                        <h5 class="mt-2">Dashboard</h5>
                    </div>
                    <p class="mt-3">Statistiques patients, actes réalisés..., Indicateurs financiers ,Gestion multi-cabinets ou multi-praticiens</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 aos" data-aos="fade-up">
                <div class="our-services-list">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <i class="fas fa-video" style="color: #26948e; font-size: 2rem;"></i>
                        <h5 class="mt-2">Téléconsultation</h5>
                    </div>
                    <p class="mt-3">Plus besoin de se déplacer, particulièrement utile pour les zones rurales ou les personnes à mobilité réduite.</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 aos" data-aos="fade-up">
                <div class="our-services-list">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <i class="fas fa-file-invoice-dollar" style="color: #26948e; font-size: 2rem;"></i>
                        <h5 class="mt-2">Gestion des flux</h5>
                    </div>
                    <p class="mt-3">Financiers et facturation pour une comptabilité fluide et sécurisée</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 aos" data-aos="fade-up">
                <div class="our-services-list">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <i class="fas fa-comments" style="color: #26948e; font-size: 2rem;"></i>
                        <h5 class="mt-2">Gestion de Communication</h5>
                    </div>
                    <p class="mt-3">Messagerie interne (entre praticiens, patients et laboratoires)</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 aos" data-aos="fade-up">
                <div class="our-services-list">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <i class="fas fa-robot" style="color: #26948e; font-size: 2rem;"></i>
                        <h5 class="mt-2">Intelligence artificielle</h5>
                    </div>
                    <p class="mt-3">Pour optimiser les durées de consultations et fiabiliser les données patients</p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- /functionality Section -->



<!-- Cursor -->
<div class="mouse-cursor cursor-outer" #cursorOuter></div>
<div class="mouse-cursor cursor-inner" #cursorInner></div>
<!-- /Cursor -->
<!-- scrollToTop start -->
<div (click)="scrollToTop()" (keydown)="scrollToTop()" tabindex="1" class="progress-wrap" [class.active-progress]="strokeValue < progress">
  <svg class="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" style="transition: stroke-dashoffset 10ms linear 0s"
          attr.stroke-dasharray="{{ progress + 'px' + ',' + progress + 'px' }}"
          attr.stroke-dashoffset="{{ strokeValue + 'px' }}"></path>
  </svg>
</div>
<!-- scrollToTop end -->
